// Fonts
import 'zignal-landscape/lib/styles/fonts/roboto.css';

import merge from 'lodash/merge';
import BaseTheme from 'zignal-landscape/lib/Dark';
import ZenLightTheme from 'themes/Light';
import WidgetsTheme from 'zignal-widgets/lib/Dark';

// Theme CSS
import 'zignal-landscape/lib/Dark.css';
import 'zignal-widgets/lib/Dark.css';

// Components
import App from 'components/App/themes/AppDark.css';
import CheckerModalForm from
  'containers/StoryAndSourceChecker/components/CheckerModalForm/themes/CheckerModalFormDark.css';
import ForgotForm from 'components/ForgotForm/themes/ForgotFormDark.css';
import LoginForm from 'containers/Login/components/LoginForm/themes/LoginFormDark.css';
import LegacyLoginForm from 'containers/Login/components/LegacyLoginForm/themes/LegacyLoginFormDark.css';
import LayoutApp from 'components/LayoutApp/themes/LayoutAppDark.css';
import Dropdown from 'containers/Notification/components/Dropdown/themes/DropdownDark.css';
import DropdownItem from 'containers/Notification/components/DropdownItem/themes/DropdownItemDark.css';
import Badge from 'containers/Notification/components/Badge/themes/BadgeDark.css';
import EmptyTable from 'components/TableLoader/components/EmptyTable/themes/EmptyTableDark.css';
import TableLoader from 'components/TableLoader/themes/TableLoaderDark.css';
import SharedLinkRow from 'containers/DashboardLinkAccess/components/SharedLinkRow/themes/SharedLinkRowDark.css';
import PrettyPrintButton from 'components/PrettyPrintButton/themes/PrettyPrintButtonDark.css';
import StoryAndSourceChecker from 'containers/StoryAndSourceChecker/themes/StoryAndSourceCheckerDark.css';
import SourceCheckerForm from
  'containers/StoryAndSourceChecker/components/SourceCheckerForm/themes/SourceCheckerFormDark.css';
import StoryCheckerForm from
  'containers/StoryAndSourceChecker/components/StoryCheckerForm/themes/StoryCheckerFormDark.css';
import Table from 'components/Table/themes/TableDark.css';
import TableIcon from 'components/TableIcon/themes/TableIconDark.css';
import ZccAdd from 'containers/Zccs/components/ZccAdd/themes/ZccAddDark.css';
import ZccListItem from 'containers/Zccs/components/ZccListItem/themes/ZccListItemDark.css';
import ZccForm from 'containers/Zccs/components/ZccForm/themes/ZccFormDark.css';
import ConfidenceSlider from 'components/ConfidenceSlider/themes/ConfidenceSliderDark.css';
import TwitterImports from 'containers/TwitterImports/themes/TwitterImportsDark.css';
import SourceCheckerResult from
  'containers/StoryAndSourceChecker/components/SourceCheckerResult/themes/SourceCheckerResultDark.css';
import StoryCheckerDetail from
  'containers/StoryAndSourceChecker/components/StoryCheckerDetail/themes/StoryCheckerDetailDark.css';
import ResultList from
  'containers/StoryAndSourceChecker/components/ResultList/themes/dark.css';
import AdminSettings from 'containers/AdminSettings/themes/dark.css';
import StoryContentMSIChecker from
  'containers/StoryAndSourceChecker/components/StoryContentMSIChecker/themes/StoryContentMSICheckerDark.css';
import CheckboxResultFilter from
  'containers/StoryAndSourceChecker/components/ResultList/components/CheckboxResultFilter/themes/dark.css';
import ReadingListStoriesSortDropdown from 'components/ReadingList/themes/ReadingListStoriesSortDropdownDark.css';
import SideBarNav from
  'containers/SideBarNav/themes/SideBarNavDark.css';
import SmartFilterPane from
  'containers/SmartFilterPane/themes/SmartFilterPaneDark.css';
import InteractiveIconHeader from 'components/InteractiveIconHeader/themes/InteractiveIconHeaderDark.css';
import Language from 'components/Language/themes/LanguageDark.css';
import LanguageSelector from 'components/LanguageSelector/themes/LanguageSelectorDark.css';

export default merge({}, ZenLightTheme, BaseTheme, WidgetsTheme, {
  App,
  CheckerModalForm,
  ForgotForm,
  LoginForm,
  LegacyLoginForm,
  LayoutApp,
  Dropdown,
  DropdownItem,
  Badge,
  EmptyTable,
  TableLoader,
  SharedLinkRow,
  StoryAndSourceChecker,
  SourceCheckerForm,
  StoryCheckerForm,
  Table,
  TableIcon,
  ZccAdd,
  ZccListItem,
  ZccForm,
  ConfidenceSlider,
  TwitterImports,
  SourceCheckerResult,
  StoryCheckerDetail,
  PrettyPrintButton,
  ResultList,
  AdminSettings,
  CheckboxResultFilter,
  StoryContentMSIChecker,
  ReadingListStoriesSortDropdown,
  SideBarNav,
  SmartFilterPane,
  InteractiveIconHeader,
  Language,
  LanguageSelector
});
